import React, { Component } from 'react';
import styles from './HQStreamerUtil.module.css';

class HQStreamerUtil extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayIndex: 0,
            wordIndex: 0,
        };

        this.icons = this.props.iconList;

        this.timer = null;
        this.completionTimer = null;
        this.hasCompletedAnimation = false;
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        this.checkAndStart();
        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.checkAndStart();
        this.scrollToBottom();
        this.checkForCompletion();
    }

    componentWillUnmount() {
        if (this.timer) clearTimeout(this.timer);
        if (this.completionTimer) clearTimeout(this.completionTimer);
    }

    scrollToBottom = () => {
        if (this.containerRef.current) {
            const container = this.containerRef.current;
            container.scrollTop = container.scrollHeight;
        }
    };

    checkAndStart = () => {
        const dataStream = this.props.dataStream || [];
        const { displayIndex } = this.state;

        if (displayIndex < dataStream.length && !this.timer) {
            this.processQueue();
        }
    };

    checkForCompletion = () => {
        const dataStream = this.props.dataStream || [];
        const { displayIndex, wordIndex } = this.state;
        const isStreamingComplete = !!this.props.isStreamingComplete;

        if (!isStreamingComplete || this.hasCompletedAnimation) {
            return;
        }

        const hasFinishedRenderingAllMessages =
            dataStream.length > 0 &&
            displayIndex >= dataStream.length - 1 &&
            wordIndex >= (dataStream[dataStream.length - 1].message || '').split(' ').length;

        if (!hasFinishedRenderingAllMessages || this.completionTimer) {
            return;
        }

        this.completionTimer = setTimeout(() => {
            this.completionTimer = null;
            this.hasCompletedAnimation = true;

            if (typeof this.props.onCompleteAnimation === 'function') {
                this.props.onCompleteAnimation();
            }
        }, 1000);
    };

    processQueue = () => {
        const dataStream = this.props.dataStream || [];
        const { displayIndex, wordIndex } = this.state;

        // Stop if we have shown all messages
        if (displayIndex >= dataStream.length) {
            this.timer = null;
            return;
        }

        const currentMessage = dataStream[displayIndex].message || '';
        const words = currentMessage.split(' ');

        if (wordIndex < words.length) {
            // Reveal next word (adjusted timing for words, e.g., 150ms)
            this.timer = setTimeout(() => {
                this.setState({ wordIndex: wordIndex + 1 }, () => {
                    this.processQueue();
                });
            }, 50); // 150
        } else {
            // Move to next message after a short pause
            this.timer = setTimeout(() => {
                this.setState({
                    displayIndex: displayIndex + 1,
                    wordIndex: 0,
                }, () => {
                    this.processQueue();
                });
            }, 100); // 300
        }
    };

    render() {
        const dataStream = this.props.dataStream || [];
        const { displayIndex, wordIndex } = this.state;

        return (
            <div ref={this.containerRef} className={styles.processingBox}>
                {dataStream.map((msg, index) => {
                    if (index > displayIndex) return null;

                    const icon = this.icons[msg.icon] || null;
                    const message = msg.message || '';
                    const words = message.split(' ');
                    const wordsToDisplay = index === displayIndex ? words.slice(0, wordIndex) : words;

                    return (
                        <div key={index} className={styles.messageRow}>
                            {icon && <div className={styles.icon}>{icon}</div>}
                            {wordsToDisplay.map((word, i) => (
                                <span key={i} className={styles.fadeWord}>
                                    {word}&nbsp;
                                </span>
                            ))}
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default HQStreamerUtil;